module.exports = __webpack_public_path__ + "static/media/FD-cover.4db6a37e.png";